<template>
  <div class="select-product">
    <!-- 搜索栏 -->
    <div class="select-product-header">
      <input class="select-product-search"
        placeholder="请输入商品名称搜索"
        v-model="searchVal"
        maxlength="50"
        @keydown.enter="getList"
      >
      <div class="select-product-btn" @click="getList">搜索</div>
    </div>

    <!-- 产品列表 -->
    <div class="select-product-list">
      <div class="select-product-item"
        v-for="item in productList"
        :key="item.id"
        @click="goToProductDetail(item.productCode)"
      >
        <div class="item-thumb" :class="CardMap[item.productName]"></div>
        <div class="item-name">{{ item.productName }}</div>
      </div>

      <template v-if="!productList.length && !loading">
        <div class="select-product-empty">暂无相关产品</div>
      </template>
    </div>

    <!-- 历史订单 悬浮按钮 -->
    <div class="select-product-history" @click="goToList">
      <div class="icon-history"></div>
    </div>
  </div>
</template>

<script>
import { findProductListByName } from "@/common/api";
import { ProductCode, CardMap } from "@/common/constant";
import { debounce } from "lodash";

export default {
  name: "select-product",
  data() {
    return {
      CardMap,
      searchVal: '',
      productList: [],
      loading: false,
    }
  },
  components: {},
  watch: {},
  methods: {
    async getListHandle () {
      this.loading = true;
      this.$toast.loading({
        message: "正在加载商品",
        forbidClick: true,
        duration: 0,
      });
      try {
        const res = await findProductListByName({
          categoryCode: ProductCode.giftCard,
          productName: this.searchVal,
          pageNum: 1,
          pageSize: 1000,
        })
        this.productList = res.list || []
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
      this.$toast.clear();
    },
    getList: debounce(async function() {
      await this.getListHandle()
    }, 500),
    goToList() {
      this.$router.push('/giftRecord')
    },
    goToProductDetail(code) {
      this.$router.push({
        path: '/giftRecharge',
        query: {
          code
        }
      });
    }
  },
  created() {
    this.getListHandle()
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/card.scss";

.select-product {
  &-header {
    position: sticky;
    left: 0;
    // 用于遮挡窗口回弹效果导致的元素穿透
    top: -1px;
    display: flex;
    padding: .18rem .24rem;
    background: #F4F6F7;
  }

  &-search {
    width: 5.96rem;
    height: .6rem;
    line-height: .6rem;
    font-size: .28rem;
    border: 1px solid #E6E9F0;
    border-radius: .08rem;
    padding: .12rem .22rem;
    box-sizing: border-box;
  }

  &-btn {
    width: .96rem;
    height: .6rem;
    line-height: .6rem;
    text-align: center;
    font-size: .3rem;
    background: #3399FF;
    color: #FFFFFF;
    margin-left: .1rem;
    border-radius: .08rem;
    box-sizing: border-box;
  }

  &-list {
    display: flex;
    flex-wrap: wrap;
    padding: .32rem .4rem;
    overflow: hidden;
  }

  &-item {
    width: 1.92rem;
    margin-right: .46rem;
    margin-bottom: .4rem;

    > .item-thumb {
      width: 1.92rem;
      height: 1.2rem;
      border-radius: .16rem;
      background-size: 1.92rem 1.2rem;
    }

    > .item-name {
      font-size: .28rem;
      font-weight: 500;
      text-align: center;
      color: #383838;
      margin-top: .16rem;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  &-empty {
    width: 100%;
    height: 5rem;
    line-height: 5rem;
    font-size: .36rem;
    color: #C8C8C8;
    text-align: center;
  }

  &-history {
    position: fixed;
    right: .3rem;
    bottom: .34rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: .84rem;
    height: .84rem;
    border-radius: 50%;
    background: rgba(255,255,255,1);
    box-shadow: 0 0 16px 0 rgba(51,153,255,0.3);

    > .icon-history {
      width: .48rem;
      height: .48rem;
      background: url("../../assets/img/car-life/icon_card_charge_history@2x.png");
      background-size: .48rem .48rem;
    }
  }
}
</style>
